import { useMutation } from '@tanstack/react-query';
import { addPet } from '@/api/profile/addPet';
import { editPet } from '@/api/profile/editPet';
import { IPet } from '@/shared/interfaces';
import { toast } from '@/shared/Toast';
import { R } from '@/features/profile/ProfileResources.resx';

type UsePetMutationProps = {
    pet?: IPet;
    onSuccess: () => void;
};

export const usePetModalMutation = ({
    pet,
    onSuccess,
}: UsePetMutationProps) => {
    const isEditing = !!pet;

    const addPetMutation = useMutation({
        mutationFn: addPet,
        onSuccess: () => onSuccess(),
        onError: () => {
            toast.addToast({
                type: 'error',
                message: R.ErrorAddPet,
            });
        },
    });

    const editPetMutation = useMutation({
        mutationFn: editPet,
        onSuccess: () => onSuccess(),
        onError: () => {
            toast.addToast({
                type: 'error',
                message: R.ErrorEditPet,
            });
        },
    });

    const onSubmit = (data: IPet) => {
        if (isPending) return;

        if (isEditing) {
            editPetMutation.mutate(data);
        } else {
            addPetMutation.mutate(data);
        }
    };

    const isPending = editPetMutation.isPending || addPetMutation.isPending;

    return {
        onSubmit,
        isPending,
    };
};
